import { useEffect, useState } from "react";
import type { Enabler } from "../types";
import { getEnablerThemes } from "../lib/resources";

type EnablerFilterProps = {
  enablers: Enabler[];
  selectedTheme: string | null;
  selectedEnabler: string | null;
  onSelectTheme: (theme: string | null) => void;
  onSelectEnabler: (code: string | null) => void;
};

export function EnablerFilter({
  enablers,
  selectedTheme,
  selectedEnabler,
  onSelectTheme,
  onSelectEnabler
}: EnablerFilterProps) {
  const themes = getEnablerThemes(enablers);
  const [openTheme, setOpenTheme] = useState<string | null>(selectedTheme);

  useEffect(() => {
    setOpenTheme(selectedTheme);
  }, [selectedTheme]);

  return (
    <section className="filter-group" aria-label="Enabler filter">
      <span className="filter-group__label">Enabler</span>
      <div className="enabler-filter">
        <div className="filter-group__options">
          <button
            className={selectedTheme === null && selectedEnabler === null ? "pill pill--active" : "pill"}
            type="button"
            onClick={() => {
              onSelectTheme(null);
              onSelectEnabler(null);
              setOpenTheme(null);
            }}
          >
            All
          </button>
          {themes.map((theme) => (
            <button
              className={selectedTheme === theme && selectedEnabler === null ? "pill pill--active" : "pill"}
              type="button"
              key={theme}
              onClick={() => {
                const nextTheme = selectedTheme === theme && selectedEnabler === null ? null : theme;
                onSelectTheme(nextTheme);
                onSelectEnabler(null);
                setOpenTheme(nextTheme);
              }}
            >
              {theme}
            </button>
          ))}
        </div>

        {selectedTheme ? (
          <div className="enabler-filter__theme">
            <button
              className="enabler-filter__toggle"
              type="button"
              aria-expanded={openTheme === selectedTheme}
              onClick={() => setOpenTheme((theme) => (theme === selectedTheme ? null : selectedTheme))}
            >
              <span>{selectedTheme} enablers</span>
              <span aria-hidden="true">{openTheme === selectedTheme ? "Hide" : "Show"}</span>
            </button>
            {openTheme === selectedTheme ? (
              <div className="filter-group__options">
                {enablers
                  .filter((enabler) => enabler.theme === selectedTheme)
                  .map((enabler) => (
                    <button
                      className={selectedEnabler === enabler.code ? "pill pill--active" : "pill"}
                      type="button"
                      key={enabler.code}
                      onClick={() => onSelectEnabler(selectedEnabler === enabler.code ? null : enabler.code)}
                    >
                      {enabler.code} {enabler.title}
                    </button>
                  ))}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}
